export const initialStateUsuario = {
   id_usuario: null,
   email: '',
   usuario: '',
   nivel: null,
   id_sucursal_interno: null,
   id_sucursal: null,
};

export function getInitialStateAuth() {
   return {
      usuario: { ...initialStateUsuario },
      access_token: null,
   };
}

export default getInitialStateAuth();
